module.exports = __webpack_public_path__ + "img/fastest.556ddf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fastest.png
// module id = 273
// module chunks = 0